<script setup lang="ts">
import {defineProps, defineEmits} from "vue"
const props = defineProps<{
    rating: number
    full: boolean
}>()
const emits = defineEmits(['choice'])
</script>

<template>
    <svg class="w-8 h-8 block cursor-pointer" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
         :data-stars="props.rating"
         :class="{'text-se-light': props.full}"
         @click="emits('choice', props.rating)">
        <path v-if="!props.full" d="M12 7.9L12.9 9.8L13.3 10.8L14.4 11L16.5 11.3L15.2 12.5L14.2 13.4L14.6 14.6L15.5 17.3L12.9 16.1L12 15.7L11.2 16.1L8.5 17.3L9.4 14.6L9.8 13.4L8.8 12.5L7.5 11.3L9.6 11L10.7 10.8L11.1 9.8L12 7.9ZM12 3L9.3 9L3 10L7.5 14L5.2 21L12 17.9L18.8 21L16.5 14L21 10L14.7 9L12 3Z" fill="currentColor"></path>
        <path v-else d="M12 3L14.7 9L21 10L16.5 14L18.8 21L12 17.9L5.2 21L7.5 14L3 10L9.3 9L12 3Z" fill="currentColor"></path>
    </svg>
</template>

<style scoped>

</style>
